import { render, staticRenderFns } from "./BodyRegister2.vue?vue&type=template&id=44ea2ec0"
import script from "./BodyRegister2.vue?vue&type=script&lang=ts"
export * from "./BodyRegister2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports